// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3e2574aa","160":"284e4516","208":"c3498916","293":"fcaf9208","453":"65c83999","516":"853373f3","519":"a5b65340","917":"f14847d3","946":"065196a9"}[chunkId] + ".chunk.js";
};